import Button from '@/components/Button';
import { FormattedMessage } from 'react-intl';
import { Photocard } from '@/types/photocard';
import { getPrice } from '@/utils/getPrice';
import { Image } from '@/components/Image';
import PageViewEvent from '@/components/Event/PageViewEvent';
import { trackEvent } from '@/components/Event/_lib/eventTrack';

interface PhotocardModalProps extends Photocard {
  onClose?: () => void;
  onAddToCart?: (offerId: number) => void;
  currency: { currency: '$' | '₩'; value: number; text: string };
}

const PhotocardDetailPage = ({ onClose, onAddToCart, currency, ...photocard }: PhotocardModalProps) => {
  return (
    <PageViewEvent
      eventName="PLP_detail_view"
      eventProps={{ group: photocard.group, member: photocard.member, photo_card_id: photocard.id, type: photocard.kind.name }}
    >
      <div
        className="absolute inset-0 w-full h-full bg-[rgba(0,0,0,0.8)] flex justify-center items-center z-10"
        onClick={(e) => {
          onClose?.();
        }}
      >
        <div
          className="w-[571px] h-[613px] rounded-[20px] bg-white"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <div className="p-[30px] pt-[30px] pb-[24px] flex flex-col gap-[24px] w-full">
            <div className="flex flex-row justify-between items-center">
              <span className="text-[30px] leading-9 font-extrabold">
                <FormattedMessage id="photocard-detail_title" defaultMessage="Details" />
              </span>
              <Image
                src="/icons/close.svg"
                alt="close icon"
                className="w-9 h-9 cursor-pointer"
                onClick={() => {
                  onClose?.();
                }}
                width={36}
                height={36}
              />
            </div>
            <div className="flex flex-row w-full gap-4">
              <Image
                src={photocard.image}
                alt="photocard"
                className="w-[204px] h-[327px] rounded-[10px] object-cover"
                width={204}
                height={327}
              />
              <div>
                <p className="text-[20px] leading-7 font-medium">{photocard.group.name_en}</p>
                <p className="text-[24px] leading-8 font-bold">{photocard.member.name_en}</p>
                <p className="text-[14px] leading-5 font-normal mt-2 mb-4 text-[#808080] h-[72px]">{photocard.name_en}</p>
                <div className="flex flex-row">
                  <div className="py-2 px-4 flex flex-row justify-center items-center rounded-[15px] border border-black">
                    <span className="text-[14px] leading-5 font-semibold">{photocard.kind.name_en}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="py-4 px-[30px] bg-[#f5f5f5] flex flex-row justify-between items-center">
            <span className="text-[20px] leading-7 font-bold">
              <FormattedMessage id="photocard-detail_price" defaultMessage="Price" />:
            </span>
            <span className="text-[20px] leading-7 font-bold">{getPrice(photocard.offer.price, currency)}</span>
          </div>
          <div className="pt-4 pb-5 px-[30px] w-full">
            <Button
              className="w-full h-[66px]"
              data-primary
              onClick={() => {
                onAddToCart?.(photocard.offer.id);
                trackEvent('PLP_detail_click_Add_button');
              }}
            >
              <FormattedMessage id="photocard-detail_cart" defaultMessage="Add to cart" />
            </Button>
          </div>
        </div>
      </div>
    </PageViewEvent>
  );
};

export default PhotocardDetailPage;
